import axios from "axios";
import { useState } from "react";
import AlertComponent from "../../components/AlertComponent";

export default function AlterarSenha() {
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    senhaAtual: "",
    novaSenha: "",
    confirmarNovaSenha: "",
  });

  const [showSenhaAtual, setShowSenhaAtual] = useState(false);
  const [showNovaSenha, setShowNovaSenha] = useState(false);
  const [showConfirmar, setShowConfirmar] = useState(false);

  const handleChange = (name) => (value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validar = () => {
    if (!form.senhaAtual?.trim()) {
      AlertComponent("Erro", "Informe a senha atual.", { icon: "error" });
      return false;
    }
    if (!form.novaSenha?.trim()) {
      AlertComponent("Erro", "Informe a nova senha.", { icon: "error" });
      return false;
    }
    if (form.novaSenha.length < 4) {
      AlertComponent("Erro", "A nova senha deve ter pelo menos 4 caracteres.", { icon: "error" });
      return false;
    }
    if (!form.confirmarNovaSenha?.trim()) {
      AlertComponent("Erro", "Confirme a nova senha.", { icon: "error" });
      return false;
    }
    if (form.novaSenha !== form.confirmarNovaSenha) {
      AlertComponent("Erro", "A confirmação não confere com a nova senha.", { icon: "error" });
      return false;
    }
    if (form.senhaAtual === form.novaSenha) {
      AlertComponent("Erro", "A nova senha não pode ser igual à senha atual.", { icon: "error" });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validar()) return;

    setLoading(true);
    try {
      await axios.put(`${process.env.REACT_APP_API}/auth/senha`, {
        senhaAtual: form.senhaAtual,
        novaSenha: form.novaSenha,
      });

      AlertComponent("Sucesso", "Senha alterada com sucesso!", { icon: "success" });

      setForm({
        senhaAtual: "",
        novaSenha: "",
        confirmarNovaSenha: "",
      });
    } catch (err) {
      console.error(err);
      AlertComponent(
        "Erro",
        err?.response?.data?.message ?? "Erro ao alterar senha",
        { icon: "error" }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto">
      {/* Header */}
      <div
        className="rounded-2xl p-6 sm:p-8 mb-6 relative overflow-hidden text-white"
        style={{ background: "linear-gradient(135deg, #1e1b4b 0%, #3b0764 100%)" }}
      >
        <div className="absolute -top-10 -right-10 w-52 h-52 rounded-full opacity-10" style={{ background: "radial-gradient(circle,#a78bfa,transparent)" }} />
        <div className="absolute -bottom-12 -left-6 w-40 h-40 rounded-full opacity-10" style={{ background: "radial-gradient(circle,#c4b5fd,transparent)" }} />
        <div className="relative">
          <p className="text-purple-300 text-sm font-medium mb-1">Segurança</p>
          <h1 className="text-2xl sm:text-3xl font-bold">Alterar senha</h1>
          <p className="text-purple-300 text-sm mt-1">Informe sua senha atual e defina uma nova senha para sua conta.</p>
        </div>
      </div>

      {/* Form */}
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-2xl shadow-sm ring-1 ring-slate-200/60 p-6 sm:p-8 space-y-5"
      >
        <PasswordInput
          label="Senha atual"
          value={form.senhaAtual}
          onChange={handleChange("senhaAtual")}
          show={showSenhaAtual}
          onToggleShow={() => setShowSenhaAtual((s) => !s)}
          placeholder="••••••••"
          autoComplete="current-password"
          disabled={loading}
          required
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <PasswordInput
            label="Nova senha"
            value={form.novaSenha}
            onChange={handleChange("novaSenha")}
            show={showNovaSenha}
            onToggleShow={() => setShowNovaSenha((s) => !s)}
            placeholder="Mínimo 4 caracteres"
            autoComplete="new-password"
            disabled={loading}
            minLength={4}
            required
          />
          <PasswordInput
            label="Confirmar nova senha"
            value={form.confirmarNovaSenha}
            onChange={handleChange("confirmarNovaSenha")}
            show={showConfirmar}
            onToggleShow={() => setShowConfirmar((s) => !s)}
            placeholder="Repita a nova senha"
            autoComplete="new-password"
            disabled={loading}
            minLength={4}
            required
          />
        </div>

        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 pt-4 border-t border-slate-100">
          <button
            type="submit"
            disabled={loading}
            className="flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold text-white
                       shadow-lg shadow-purple-900/30 hover:shadow-purple-900/50 transition-all duration-200
                       hover:-translate-y-0.5 active:translate-y-0
                       disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:shadow-none"
            style={{ background: "linear-gradient(135deg,#7c3aed,#6d28d9)" }}
          >
            {loading ? (
              <>
                <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                </svg>
                Salvando...
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Alterar senha
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

function PasswordInput({ label, value, onChange, show, onToggleShow, placeholder, autoComplete, disabled, required, minLength }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-slate-600 uppercase tracking-wider mb-2">
        {label}{required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      <div className="relative">
        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-slate-400">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </span>
        <input
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={required}
          minLength={minLength}
          disabled={disabled}
          className="w-full rounded-xl border border-slate-200 bg-slate-50/50 pl-10 pr-10 py-2.5 text-sm text-slate-900 placeholder-slate-400
                     focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent focus:bg-white transition
                     disabled:opacity-60 disabled:cursor-not-allowed"
        />
        <button
          type="button"
          onClick={onToggleShow}
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 hover:text-violet-600 transition"
          tabIndex={-1}
          aria-label={show ? "Ocultar senha" : "Mostrar senha"}
        >
          {show ? (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
            </svg>
          ) : (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}
